module.exports = __webpack_public_path__ + "957458bb5e5acc85933aab47bb9393cf.png";